import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";

/* siehe PrivateRoute in
 * https://reacttraining.com/react-router/web/example/auth-workflow
 */
const AuthorizedRoute = ({ component: Component, authorized, ...args}) => (
	<Route
		{...args}
		render={props => {
			return authorized === true
				? <Component {...props} />
				: <Redirect to={{
					pathname: "/",
					state: { from: props.location }
				}} />;
		}} />
);

AuthorizedRoute.propTypes = {
	component: PropTypes.oneOfType([
		PropTypes.element, PropTypes.func
	]),
	location: PropTypes.object,
	authorized: PropTypes.bool
};

export default AuthorizedRoute;
